import {DataFetcher} from '@aboutyou/data-fetcher';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {DeliveriesProps} from '../Deliveries/Deliveries';
import {useUnavailableProducts} from '../hooks/useGetBasketPageSection';
import {UnavailableProductsSkeleton} from './UnavailableProducts.skeleton';
import {UnavailableProductsView} from './UnavailableProductsView';

export interface UnavailableProductsProps extends DeliveriesProps {
  SizeReminderLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const UnavailableProducts: FC<UnavailableProductsProps> = props => {
  return (
    <DataFetcher
      request={useUnavailableProducts()}
      Error={() => null}
      View={UnavailableProductsView}
      Loading={UnavailableProductsSkeleton}
      viewProps={props}
    />
  );
};
